import { render } from "./Sv036.vue?vue&type=template&id=77b53fec&scoped=true"
import script from "./Sv036.vue?vue&type=script&lang=js"
export * from "./Sv036.vue?vue&type=script&lang=js"

import "./Sv036.vue?vue&type=style&index=0&id=77b53fec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b53fec"]])

export default __exports__